import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";

/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/
import logFactory from '../utils/logger';
var log = logFactory('splitio-producer:task');
import repeat from '../utils/fn/repeat';
import { getFnName } from '../utils/lang';
/**
 * Startable task factory.
 */

var TaskFactory = function TaskFactory(updater, period) {
  var updaterName = getFnName(updater);
  var stopUpdater = false;
  return {
    start: function start() {
      if (!stopUpdater) {
        var _context;
        log.debug(_concatInstanceProperty(_context = "Starting ".concat(updaterName, " refreshing each ")).call(_context, period));
        stopUpdater = repeat(function (reschedule) {
          log.debug("Running ".concat(updaterName));
          updater().then(function () {
            return reschedule();
          });
        }, period);
      }
    },
    stop: function stop() {
      log.debug("Stopping ".concat(updaterName));
      stopUpdater && stopUpdater();
      stopUpdater = false;
    },
    isRunning: function isRunning() {
      return stopUpdater ? true : false;
    }
  };
};
export default TaskFactory;